<template>
  <v-dialog
    :value="show"
    persistent
    :fullscreen="$vuetify.breakpoint.xsOnly"
    :width="$store.state.common.largeDialogWidth"
    @input="val = $emit('update:show', val)"
  >
    <v-card>
      <v-card-title class="pb-0">
        <v-layout align-center>
          <v-layout
            class="headline"
            align-center
          >
            <v-icon
              class="mr-3"
              color="msr"
            >
              email
            </v-icon>
            {{ $t('changeEmail') }}
          </v-layout>
          <v-btn
            class="ml-auto mr-0 my-0"
            flat
            icon
            :title="$t('cancel')"
            data-cy="change-email-dialog-abort-btn"
            @click="abort()"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-layout>
      </v-card-title>
      <v-card-text>
        <v-layout column>
          <v-text-field
            v-model="oldEmail"
            :label="$t('oldEmail')"
            class="v-text-custom-disabled"
            disabled
          />
          <v-form
            ref="emailForm"
            v-model="emailFormIsValid"
            @submit.prevent
          >
            <v-text-field
              v-model="newEmail"
              :label="$t('newEmail')"
              :rules="[rules.email]"
              type="email"
              autofocus
              required
              @keyup.native.esc="abort()"
              @keyup.native.enter="confirm()"
            />
          </v-form>
          <div class="grey--text">
            {{ $t('changeEmailInfo') }}
          </div>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-layout justify-center>
          <btn-ok
            :disabled="!emailFormIsValid"
            data-cy="change-email-dialog-confirm-btn"
            round
            @click="confirm()"
          />
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import BtnOk from '@/components/ButtonOk';

export default {
  components: {
    BtnOk,
  },
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    oldEmail: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      emailFormIsValid: false,
      newEmail: '',
      rules: {
        email: (value) => {
          // See: https://stackoverflow.com/questions/46155
          const differs = value !== this.oldEmail;
          const patternUnicodeEmail =
            /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
          return (
            (differs && patternUnicodeEmail.test(value)) ||
            this.$t('invalidEmail')
          );
        },
      },
    };
  },
  methods: {
    confirm() {
      if (!this.emailFormIsValid) {
        return;
      }
      this.$emit('submitted');
    },
    abort() {
      this.$emit('aborted');
    },
    reset() {
      this.$refs.emailForm.reset();
      this.newEmail = '';
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ChangeEmailDialog.vue